import { StandardEvents } from '@shopify/events';

class CartDrawerUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-cart-upsell-button]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const line = Number(this.dataset.cartLine);
    const cartItems = this.closest('cart-items-component');

    if (!Number.isInteger(line) || line < 1 || !cartItems || typeof cartItems.updateQuantity !== 'function') return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    const releaseButton = (updateEvent) => {
      if (updateEvent.target !== cartItems) return;

      document.removeEventListener(StandardEvents.cartLinesUpdate, releaseButton);
      updateEvent.promise
        ?.finally(() => {
          if (!button.isConnected) return;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    };

    document.addEventListener(StandardEvents.cartLinesUpdate, releaseButton);

    try {
      cartItems.updateQuantity({
        line,
        quantity: 2,
        action: 'change',
      });
    } catch (error) {
      document.removeEventListener(StandardEvents.cartLinesUpdate, releaseButton);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      throw error;
    }
  };
}

if (!customElements.get('cart-drawer-upsell')) {
  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}
